"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var isUndefined_1 = tslib_1.__importDefault(require("lodash/isUndefined"));
var _pagination_1 = tslib_1.__importDefault(require("../_components/_pagination"));
var input_1 = tslib_1.__importDefault(require("../input"));
var select_1 = tslib_1.__importDefault(require("../select"));
var usePersistFn_1 = tslib_1.__importDefault(require("../util/hooks/usePersistFn"));
var Option = select_1.default.Option;
var useInputFormatter = input_1.default.useInputFormatter;
var defaultPageSizeOptions = ['10', '20', '50', '100'];
function calculatePage(pageSize, total) {
    return Math.floor((total - 1) / pageSize) + 1;
}
var AnqPagination = function (props) {
    var pageSize = props.pageSize, onChange = props.onChange, pageSizeOptions = props.pageSizeOptions, defaultPageSize = props.defaultPageSize, showTotal = props.showTotal, _a = props.showSizeChanger, showSizeChanger = _a === void 0 ? false : _a, current = props.current, onShowSizeChange = props.onShowSizeChange, defaultCurrent = props.defaultCurrent, showQuickJumper = props.showQuickJumper, className = props.className, style = props.style, rest = tslib_1.__rest(props, ["pageSize", "onChange", "pageSizeOptions", "defaultPageSize", "showTotal", "showSizeChanger", "current", "onShowSizeChange", "defaultCurrent", "showQuickJumper", "className", "style"]);
    var ref = (0, react_1.useRef)(null);
    var _b = tslib_1.__read(useInputFormatter({
        formatter: 'number',
    }), 1), inputProps = _b[0];
    var targetPage = inputProps.value, setTargetPage = inputProps.onChange;
    var _c = tslib_1.__read((0, react_1.useState)(defaultPageSize || 10), 2), currentPageSize = _c[0], setCurrentPageSize = _c[1];
    var _d = tslib_1.__read((0, react_1.useState)(current || defaultCurrent || 1), 2), currentPageNumber = _d[0], setCurrentPageNumber = _d[1];
    var customPageSize = pageSize || currentPageSize;
    var customPageSizeOptions = pageSizeOptions || defaultPageSizeOptions;
    var handleSelectChange = (0, usePersistFn_1.default)(function (selectedPageSize) {
        setCurrentPageSize(+selectedPageSize);
        var pageNumber = 1;
        if (currentPageNumber * selectedPageSize <= props.total) {
            pageNumber = currentPageNumber;
        }
        else {
            pageNumber = calculatePage(+selectedPageSize, props.total);
        }
        setCurrentPageNumber(pageNumber);
        onChange && onChange(pageNumber, +selectedPageSize);
        onShowSizeChange && onShowSizeChange(pageNumber, +selectedPageSize);
    });
    var pageSizeChanger = (0, usePersistFn_1.default)(function () {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("span", { className: "anq-perpage-text" }, "\u6BCF\u9875"),
            react_1.default.createElement(select_1.default, { style: { width: 72 }, onChange: handleSelectChange, defaultValue: defaultPageSize || 10, value: customPageSize, getPopupContainer: function (triggerNode) { return triggerNode.parentElement; } }, customPageSizeOptions.map(function (option, index) { return (react_1.default.createElement(Option, { value: option, key: index }, option)); })),
            react_1.default.createElement("span", { className: "anq-item-text" }, "\u6761")));
    });
    var totalBlock = (0, usePersistFn_1.default)(function (total, range) {
        if (showTotal) {
            return showTotal(total, range);
        }
        return react_1.default.createElement(react_1.default.Fragment, null,
            "\u5171 ",
            total,
            " \u6761");
    });
    var sizeChargerBlock = (0, usePersistFn_1.default)(function () {
        if (showSizeChanger) {
            return pageSizeChanger();
        }
        return react_1.default.createElement(react_1.default.Fragment, null);
    });
    var handleShowTotal = (0, usePersistFn_1.default)(function (total, range) {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            totalBlock(total, range),
            sizeChargerBlock()));
    });
    var handleChange = (0, usePersistFn_1.default)(function (pageNumber, pageSize) {
        onChange && onChange(pageNumber, pageSize);
        if ((0, isUndefined_1.default)(current)) {
            setCurrentPageNumber(pageNumber);
        }
    });
    var jumpTargetPage = (0, react_1.useMemo)(function () {
        var maxPage = Math.ceil(props.total / customPageSize);
        var minPage = 1;
        if (+targetPage >= maxPage) {
            return maxPage;
        }
        if (+targetPage <= minPage) {
            return minPage;
        }
        return +targetPage;
    }, [props.total, customPageSize, targetPage]);
    var handlePressEnter = (0, usePersistFn_1.default)(function (e) {
        setTargetPage(e);
        handleChange(jumpTargetPage, customPageSize);
    });
    (0, react_1.useEffect)(function () {
        if (!(0, isUndefined_1.default)(current)) {
            setCurrentPageNumber(current);
        }
    }, [current]);
    (0, react_1.useEffect)(function () {
        var _a;
        var inputEle = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.querySelector('input');
        if (props.simple && inputEle) {
            inputEle.onchange = function (e) {
                onChange && onChange(+e.target.value, currentPageSize);
            };
        }
    }, [ref, currentPageSize, onChange, props.simple]);
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)('anq-pagination-wrapper', className), ref: ref, style: style },
        react_1.default.createElement(_pagination_1.default, tslib_1.__assign({ size: "small", pageSize: customPageSize, showTotal: handleShowTotal, onChange: handleChange, current: currentPageNumber }, rest)),
        showQuickJumper && (react_1.default.createElement("div", { className: "anq-pagination-target" },
            react_1.default.createElement("span", null, "\u8DF3\u8F6C\u81F3"),
            react_1.default.createElement(input_1.default, { className: "anq-pagination-target-input", value: targetPage, onChange: setTargetPage, onPressEnter: handlePressEnter }),
            react_1.default.createElement("span", null, "\u9875")))));
};
exports.default = AnqPagination;
//# sourceMappingURL=index.js.map